export const transformNumberToBoolean = (numberValue: number): boolean => {
  if (!isFinite(numberValue)) {
    return false;
  } else {
    return numberValue !== 0;
  }
};
